export default [
  // 权限路由
  {
    path: '/',
    redirect: '/survey',
    hidden: true // 是否展示在侧边栏的菜单里
  },
  // 数据概览
  {
    path: '/survey',
    component: 'Layout',
    redirect: '/survey/index',
    meta: {
      menuName: 'Survey', // 一级菜单标题
      icon: 'icon-caiwu', // 一级菜单的图标
      subNavName: [{
        name: 'SurveyManage',
        url: [{
          name: 'Survey',
          url: '/survey/index'
        }, {
          name: 'SurveyCity',
          url: '/survey/city'
        }]
      }]
    },
    children: [{
      path: 'index',
      name: 'Survey',
      component: '/survey/index',
      meta: {
        refresh: false,
        title: 'SurveyManage', // 页面头部的标题
        isOnly: true, // 单独页面
        auth: [], // 单独页面按钮操作权限
        pagePermission: [{
          title: 'Survey',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'city',
      name: 'SurveyCity',
      component: '/survey/city',
      meta: {
        refresh: false,
        title: 'SurveyManage',
        isOnly: true,
        auth: [],
        pagePermission: [{
          title: 'SurveyCity',
          index: 0,
          auth: ['pagedata', 'cityFind', 'openCity']
        }]
      }
    }]
  },
  // 技-师数据
  {
    path: '/data',
    component: 'Layout',
    redirect: '/data/index',
    meta: {
      menuName: 'Data',
      icon: 'iconshujufenxi'
    },
    children: [{
      path: 'index',
      name: 'Data',
      component: '/data/index',
      meta: {
        refresh: false,
        title: '',
        isOnly: true,
        auth: [],
        pagePermission: [{
          title: 'Data',
          index: 0,
          auth: ['pagedata', 'export']
        }]
      }
    }]
  },
  // 物料商城
  {
    path: '/mall',
    component: 'Layout',
    redirect: '/mall/sort',
    meta: {
      menuName: 'Mall',
      icon: 'icon-gouwudai',
      subNavName: [{
        name: 'MallManage',
        url: [{
          name: 'MallSort',
          url: '/mall/sort'
        }, {
          name: 'MallGoodList',
          url: '/mall/list'
        }]
      }]
    },
    children: [{
      path: 'sort',
      name: 'MallSort',
      component: '/mall/sort',
      meta: {
        title: 'MallManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MallSort',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'list',
      name: 'MallGoodList',
      component: '/mall/list',
      meta: {
        keepAlive: true,
        title: 'MallManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MallGoodList',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'edit',
      name: 'MallGoodEdit',
      component: '/mall/edit',
      hidden: true,
      meta: {
        title: 'MallManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MallGoodEdit',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 服务管理
  {
    path: '/service',
    component: 'Layout',
    redirect: '/service/classify',
    meta: {
      menuName: 'Service',
      icon: 'icon-yuyue',
      subNavName: [{
        name: 'ServiceManage',
        url: [{
          name: 'ServiceClassify',
          url: '/service/classify'
        }, {
          name: 'ServiceManage',
          url: '/service/list'
        }, {
          name: 'ServiceBell',
          url: '/service/bell'
        }, {
          name: 'ServiceExamine',
          url: '/service/examine'
        }]
      }, {
        name: 'ServiceSet',
        url: [{
          name: 'ServiceBannerList',
          url: '/service/banner'
        }, {
          name: 'ServiceBellSet',
          url: '/service/bell-set'
        }, {
          name: 'ServiceMaterialSet',
          url: '/service/material-set'
        }]
      }]
    },
    children: [{
      path: 'classify',
      name: 'ServiceClassify',
      component: '/service/classify',
      meta: {
        keepAlive: true,
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceClassify',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'list',
      name: 'ServiceManage',
      component: '/service/service/list',
      meta: {
        keepAlive: true,
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceManage',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'service/edit',
      name: 'ServiceEdit',
      component: '/service/service/edit',
      hidden: true,
      meta: {
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'bell',
      name: 'ServiceBell',
      component: '/service/bell/list',
      meta: {
        keepAlive: true,
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceBell',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'bell/edit',
      name: 'ServiceBellEdit',
      component: '/service/bell/edit',
      hidden: true,
      meta: {
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceBellEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'examine',
      name: 'ServiceExamine',
      component: '/service/service/examine',
      meta: {
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceExamine',
          index: 0,
          auth: ['pagedata', 'examine', 'view', 'delete']
        }]
      }
    }, {
      path: 'banner',
      name: 'ServiceBannerList',
      component: '/service/set/list',
      meta: {
        keepAlive: true,
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceBannerList',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'banner/edit',
      name: 'ServiceBannerEdit',
      component: '/service/set/edit',
      hidden: true,
      meta: {
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceBannerEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'bell-set',
      name: 'ServiceBellSet',
      component: '/service/set/bell-set',
      meta: {
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceBellSet',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'material-set',
      name: 'ServiceMaterialSet',
      component: '/service/set/material-set',
      meta: {
        title: 'ServiceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ServiceMaterialSet',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 技-师管理
  {
    path: '/technician',
    component: 'Layout',
    redirect: '/technician/list',
    meta: {
      menuName: 'Technician',
      icon: 'iconshenqingjishi3',
      subNavName: [{
        name: 'TechnicianManage',
        url: [{
          name: 'TechnicianManage',
          url: '/technician/list'
        }, {
          name: 'TechnicianLevel',
          url: '/technician/level'
        }, {
          name: 'TechnicianSet',
          url: '/technician/set'
        }, {
          name: 'TechnicianPendant',
          url: '/technician/pendant'
        }
        ]
      }]
    },
    children: [{
      path: 'list',
      name: 'TechnicianManage',
      component: '/technician/list',
      meta: {
        keepAlive: true,
        title: 'TechnicianManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'TechnicianManage',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete', 'authTechnician', 'resetExamine', 'cancelAuth', 'resetAuth', 'authenticationExamine', 'updateAgent']
        }]
      }
    }, {
      path: 'edit',
      name: 'TechnicianEdit',
      component: '/technician/edit',
      hidden: true,
      meta: {
        title: 'TechnicianManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'TechnicianEdit',
          index: 0,
          auth: ['updateCoachbroker', 'coachEditOrderList', 'coachEditServiceList', 'coachEditJoinService', 'coachEditDelService', 'coachEditChangeServicePrice', 'coachEditBalanceList']
        }]
      }
    }, {
      path: 'level',
      name: 'TechnicianLevel',
      component: '/technician/level',
      meta: {
        title: 'TechnicianManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'TechnicianLevel',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete', 'setCycle']
        }]
      }
    }, {
      path: 'set',
      name: 'TechnicianSet',
      component: '/technician/set',
      meta: {
        title: 'TechnicianManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'TechnicianSet',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'pendant',
      name: 'TechnicianPendant',
      component: '/technician/pendant',
      meta: {
        title: 'TechnicianManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'TechnicianPendant',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 订单管理
  {
    path: '/shop',
    component: 'Layout',
    redirect: '/shop/order/list',
    meta: {
      menuName: 'Shop',
      icon: 'icon-dingdanguanli',
      subNavName: [{
        name: 'ShopOrderManage',
        url: [{
          name: 'ShopOrder',
          url: '/shop/order/list'
        }, {
          name: 'ShopBellOrder',
          url: '/shop/order/bell'
        }, {
          name: 'ShopRefuseOrder',
          url: '/shop/order/refuse'
        }]
      }, {
        name: 'ShopAbnormalManage',
        url: [{
          name: 'ShopAbnormalOrder',
          url: '/shop/abnormal/list'
        }, {
          name: 'ShopAbnormalSet',
          url: '/shop/abnormal/set'
        }]
      }, {
        name: 'ShopRefundManage',
        url: [{
          name: 'ShopRefund',
          url: '/shop/refund/list'
        },
        {
          name: 'ShopBellRefund',
          url: '/shop/refund/bell'
        }]
      }, {
        name: 'ShopEvaluate',
        url: [{
          name: 'ShopEvaluateLabel',
          url: '/shop/evaluate/label'
        },
        {
          name: 'ShopEvaluate',
          url: '/shop/evaluate/list'
        }]
      }, {
        name: 'ShopCommission',
        url: [{
          name: 'ShopCommissiondistribution',
          url: '/shop/commission/distribution'
        }]
      }]
    },
    children: [{
      path: 'order/list',
      name: 'ShopOrder',
      component: '/shop/order/list',
      meta: {
        keepAlive: true,
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopOrder',
          index: 0,
          // auth: ['pagedata', 'view', 'print', 'export', 'transferOrder', 'orderTaking', 'setOut', 'arrive', 'startService', 'serviceCompletion', 'operRefund', 'operAbnormal']
          auth: ['pagedata', 'view', 'print', 'export', 'transferOrder', 'orderTaking', 'setOut', 'arrive', 'startService', 'serviceCompletion', 'operAbnormal']
        }]
      }
    }, {
      path: 'order/bell',
      name: 'ShopBellOrder',
      component: '/shop/order/bell',
      meta: {
        keepAlive: true,
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopBellOrder',
          index: 0,
          auth: ['pagedata', 'view', 'print', 'export', 'orderTaking', 'startService', 'serviceCompletion']
        }]
      }
    }, {
      path: 'order/refuse',
      name: 'ShopRefuseOrder',
      component: '/shop/order/refuse',
      meta: {
        keepAlive: true,
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopRefuseOrder',
          index: 0,
          auth: ['pagedata', 'transferOrder', 'agreeRefund']
        }]
      }
    }, {
      path: 'order/detail',
      name: 'ShopOrderDetail',
      component: '/shop/order/detail',
      hidden: true,
      meta: {
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopOrderDetail',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'abnormal/list',
      name: 'ShopAbnormalOrder',
      component: '/shop/abnormal/list',
      meta: {
        keepAlive: true,
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopAbnormalOrder',
          index: 0,
          auth: ['pagedata', 'view']
        }]
      }
    }, {
      path: 'abnormal/detail',
      name: 'ShopAbnormalOrderDetail',
      component: '/shop/abnormal/detail',
      hidden: true,
      meta: {
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopAbnormalOrderDetail',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'abnormal/set',
      name: 'ShopAbnormalSet',
      component: '/shop/abnormal/set',
      meta: {
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopAbnormalSet',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'abnormal/node',
      name: 'ShopAbnormalNode',
      component: '/shop/abnormal/node',
      hidden: true,
      meta: {
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopAbnormalNode',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'refund/list',
      name: 'ShopRefund',
      component: '/shop/refund/list',
      meta: {
        keepAlive: true,
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopRefund',
          index: 0,
          auth: ['pagedata', 'view', 'agreeRefund', 'rejectRefund']
        }]
      }
    }, {
      path: 'refund/bell',
      name: 'ShopBellRefund',
      component: '/shop/refund/bell',
      meta: {
        keepAlive: true,
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopBellRefund',
          index: 0,
          auth: ['pagedata', 'view', 'agreeRefund', 'rejectRefund']
        }]
      }
    }, {
      path: 'refund/detail',
      name: 'ShopRefundDetail',
      component: '/shop/refund/detail',
      hidden: true,
      meta: {
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopRefundDetail',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'evaluate/label',
      name: 'ShopEvaluateLabel',
      component: '/shop/evaluate/label',
      meta: {
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopEvaluateLabel',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'evaluate/list',
      name: 'ShopEvaluate',
      component: '/shop/evaluate/list',
      meta: {
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopEvaluate',
          index: 0,
          auth: ['pagedata', 'add', 'delete']
        }]
      }
    }, {
      path: 'commission/distribution',
      name: 'ShopCommissiondistribution',
      component: '/shop/commission/distribution',
      meta: {
        title: 'ShopOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ShopCommissiondistribution',
          index: 0,
          auth: ['pagedata', 'export']
        }]
      }
    }]
  },
  // 分销员管理
  {
    path: '/distribution',
    component: 'Layout',
    redirect: '/distribution/examine',
    meta: {
      menuName: 'Distribution',
      icon: 'icon-zuzhi',
      subNavName: [{
        name: 'DistributionManage',
        url: [{
          name: 'DistributionExamine',
          url: '/distribution/examine'
        }, {
          name: 'DistributionCount',
          url: '/distribution/count'
        }, {
          name: 'DistributionSet',
          url: '/distribution/set'
        }]
      }, {
        name: 'DistributionApplyOrderManage',
        url: [{
          name: 'DistributionApplyOrder',
          url: '/distribution/payorder'
        }]
      }]
    },
    children: [{
      path: 'examine',
      name: 'DistributionExamine',
      component: '/distribution/examine',
      meta: {
        title: 'DistributionManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionExamine',
          index: 0,
          auth: ['pagedata', 'view', 'edit', 'delete', 'authDistribution', 'cancelAuth', 'resetAuth', 'updateAgent', 'updateTopBind']
        }]
      }
    }, {
      path: 'edit',
      name: 'DistributionEdit',
      component: '/distribution/edit',
      hidden: true,
      meta: {
        title: 'DistributionManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'count',
      name: 'DistributionCount',
      component: '/distribution/count',
      meta: {
        keepAlive: true,
        title: 'DistributionManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionCount',
          index: 0,
          auth: ['pagedata', 'distributionFind', 'inviteDistribution', 'inviteUser', 'cancelBindUser']
        }]
      }
    }, {
      path: 'find',
      name: 'DistributionFind',
      component: '/distribution/find',
      hidden: true,
      meta: {
        title: 'DistributionManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionFind',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'set',
      name: 'DistributionSet',
      component: '/distribution/set',
      meta: {
        title: 'DistributionManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionSet',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'payorder',
      name: 'DistributionApplyOrder',
      component: '/distribution/payorder',
      meta: {
        keepAlive: true,
        title: 'DistributionApplyOrderManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DistributionApplyOrder',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 经纪人管理
  {
    path: '/coachbroker',
    component: 'Layout',
    redirect: '/coachbroker/examine',
    meta: {
      menuName: 'Coachbroker',
      icon: 'iconjingjieren',
      subNavName: [{
        name: 'CoachbrokerManage',
        url: [{
          name: 'CoachbrokerExamine',
          url: '/coachbroker/examine'
        }, {
          name: 'CoachbrokerCount',
          url: '/coachbroker/count'
        }, {
          name: 'CoachbrokerSet',
          url: '/coachbroker/set'
        }]
      }]
    },
    children: [{
      path: 'examine',
      name: 'CoachbrokerExamine',
      component: '/coachbroker/examine',
      meta: {
        title: 'CoachbrokerManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CoachbrokerExamine',
          index: 0,
          auth: ['pagedata', 'view', 'add', 'edit', 'delete', 'authCoachbroker', 'cancelAuth', 'resetAuth']
        }]
      }
    }, {
      path: 'edit',
      name: 'CoachbrokerEdit',
      component: '/coachbroker/edit',
      hidden: true,
      meta: {
        title: 'CoachbrokerManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CoachbrokerEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'count',
      name: 'CoachbrokerCount',
      component: '/coachbroker/count',
      meta: {
        keepAlive: true,
        title: 'CoachbrokerManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CoachbrokerCount',
          index: 0,
          auth: ['pagedata', 'inviteTechnician']
        }]
      }
    }, {
      path: 'level',
      name: 'CoachbrokerLevel',
      component: '/coachbroker/level',
      hidden: true,
      meta: {
        title: 'CoachbrokerManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CoachbrokerLevel',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'set',
      name: 'CoachbrokerSet',
      component: '/coachbroker/set',
      meta: {
        title: 'CoachbrokerManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CoachbrokerSet',
          index: 0,
          auth: ['edit', 'coachbrokerLevelView', 'coachbrokerLevelAdd', 'coachbrokerLevelEdit', 'coachbrokerLevelDel']
        }]
      }
    }]
  },
  // 业务员管理
  {
    path: '/salesman',
    component: 'Layout',
    redirect: '/salesman/examine',
    meta: {
      menuName: 'Salesman',
      icon: 'icon-account-line',
      subNavName: [{
        name: 'SalesmanManage',
        url: [{
          name: 'SalesmanExamine',
          url: '/salesman/examine'
        }, {
          name: 'SalesmanCount',
          url: '/salesman/count'
        }, {
          name: 'SalesmanSet',
          url: '/salesman/set'
        }]
      }]
    },
    children: [{
      path: 'examine',
      name: 'SalesmanExamine',
      component: '/salesman/examine',
      meta: {
        title: 'SalesmanManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'SalesmanExamine',
          index: 0,
          auth: ['pagedata', 'view', 'delete', 'authSalesman', 'cancelAuth', 'resetAuth', 'bindChannel', 'updateAgent', 'resetSalesman', 'deleteChannel', 'setSalesmanBalance', 'delSalesmanBalance']
        }]
      }
    }, {
      path: 'count',
      name: 'SalesmanCount',
      component: '/salesman/count',
      meta: {
        title: 'SalesmanManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'SalesmanCount',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'channel',
      name: 'SalesmanChannel',
      component: '/salesman/channel',
      hidden: true,
      meta: {
        title: 'SalesmanManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'SalesmanChannel',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'set',
      name: 'SalesmanSet',
      component: '/salesman/set',
      meta: {
        title: 'SalesmanManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'SalesmanSet',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 渠道商管理
  {
    path: '/channel',
    component: 'Layout',
    redirect: '/channel/examine',
    meta: {
      menuName: 'Channel',
      icon: 'iconwoshiqudaoshang',
      subNavName: [{
        name: 'ChannelManage',
        url: [{
          name: 'ChannelExamine',
          url: '/channel/examine'
        }, {
          name: 'ChannelClassify',
          url: '/channel/classify'
        }, {
          name: 'ChannelFinance',
          url: '/channel/finance'
        }, {
          name: 'ChannelSet',
          url: '/channel/set'
        }]
      }, {
        name: 'ChannelQrManage',
        url: [{
          name: 'ChannelQr',
          url: '/channel/qr'
        }, {
          name: 'ChannelQrCount',
          url: '/channel/count'
        }]
      }]
    },
    children: [{
      path: 'examine',
      name: 'ChannelExamine',
      component: '/channel/examine',
      meta: {
        title: 'ChannelManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ChannelExamine',
          index: 0,
          auth: ['pagedata', 'view', 'add', 'edit', 'delete', 'authChannel', 'cancelAuth', 'resetAuth', 'updateAgentSalesman', 'setChannelBalance', 'delChannelBalance']
        }]
      }
    }, {
      path: 'edit',
      name: 'ChannelEdit',
      component: '/channel/edit',
      hidden: true,
      meta: {
        title: 'ChannelManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ChannelEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'classify',
      name: 'ChannelClassify',
      component: '/channel/classify',
      meta: {
        title: 'ChannelManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ChannelClassify',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'finance',
      name: 'ChannelFinance',
      component: '/channel/finance',
      meta: {
        title: 'ChannelManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ChannelFinance',
          index: 0,
          auth: ['pagedata', 'print', 'export']
        }]
      }
    }, {
      path: 'set',
      name: 'ChannelSet',
      component: '/channel/set',
      meta: {
        title: 'ChannelManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ChannelSet',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'qr',
      name: 'ChannelQr',
      component: '/channel/qr',
      meta: {
        title: 'ChannelManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ChannelQr',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete', 'downloadQr', 'batchDownloadQr', 'batchDelete', 'batchBindChannel', 'setChannelQrBalance']
        }]
      }
    }, {
      path: 'count',
      name: 'ChannelQrCount',
      component: '/channel/count',
      meta: {
        title: 'ChannelManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'ChannelQrCount',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 代理商
  {
    path: '/agent',
    component: 'Layout',
    redirect: '/agent/account',
    meta: {
      menuName: 'Agent',
      icon: 'icon-person-accounts',
      subNavName: [{
        name: 'AgentManage',
        url: [{
          name: 'AgentAccount',
          url: '/agent/account'
        }, {
          name: 'AgentApply',
          url: '/agent/apply'
        }, {
          name: 'AgentSet',
          url: '/agent/set'
        }]
      }]
    },
    children: [{
      path: 'account',
      name: 'AgentAccount',
      component: '/agent/account',
      meta: {
        title: 'AgentManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AgentAccount',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'apply',
      name: 'AgentApply',
      component: '/agent/apply',
      meta: {
        title: 'AgentManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AgentApply',
          index: 0,
          auth: ['pagedata', 'read']
        }]
      }
    }, {
      path: 'set',
      name: 'AgentSet',
      component: '/agent/set',
      meta: {
        title: 'AgentManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AgentSet',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 营销管理
  {
    path: '/market',
    component: 'Layout',
    redirect: '/market/article/list',
    meta: {
      menuName: 'Market',
      icon: 'icon-yingxiao',
      subNavName: [{
        name: 'MarketManage',
        url: [{
          name: 'MarketArticle',
          url: '/market/article/list'
        }, {
          name: 'MarketCoupon',
          url: '/market/coupon/list'
        }, {
          name: 'MarketAtv',
          url: '/market/atv'
        }]
      }]
    },
    children: [{
      path: 'article/list',
      name: 'MarketArticle',
      component: '/market/article/list',
      meta: {
        keepAlive: true,
        title: 'MarketManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MarketArticle',
          url: 'list',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete', 'formData']
        }, {
          title: 'MarketArticleEnroll',
          url: 'enroll',
          index: 1,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'article/enroll',
      name: 'MarketArticleEnroll',
      component: '/market/article/enroll',
      meta: {
        title: 'MarketManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MarketArticleList',
          url: 'list',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete', 'formData']
        }, {
          title: 'MarketArticleEnroll',
          url: 'enroll',
          index: 1,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'article/edit',
      name: 'MarketArticleEdit',
      component: '/market/article/edit',
      hidden: true,
      meta: {
        title: 'MarketManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MarketArticleEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'article/record',
      name: 'MarketArticleRecord',
      component: '/market/article/record',
      hidden: true,
      meta: {
        title: 'MarketManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MarketArticleRecord',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'coupon/list',
      name: 'MarketCoupon',
      component: '/market/coupon/list',
      meta: {
        keepAlive: true,
        title: 'MarketManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MarketCoupon',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete', 'handOut']
        }]
      }
    }, {
      path: 'coupon/edit',
      name: 'MarketCouponEdit',
      component: '/market/coupon/edit',
      hidden: true,
      meta: {
        title: 'MarketManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MarketCouponEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'atv',
      name: 'MarketAtv',
      component: '/market/atv',
      meta: {
        title: 'MarketManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'MarketAtv',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 财务管理
  {
    path: '/finance',
    component: 'Layout',
    redirect: '/finance/stored/list',
    meta: {
      menuName: 'Finance',
      icon: 'icon-caiwuguanli',
      subNavName: [{
        name: 'FinanceStored',
        url: [{
          name: 'FinanceStored',
          url: '/finance/stored/list'
        }, {
          name: 'FinanceStoredOrder',
          url: '/finance/stored/order'
        }, {
          name: 'FinanceStoredSet',
          url: '/finance/stored/set'
        }]
      }, {
        name: 'FinanceManage',
        url: [{
          name: 'FinanceManage',
          url: '/finance/list'
        }, {
          name: 'FinanceRecord',
          url: '/finance/record'
        }, {
          name: 'FinanceOrder',
          url: '/finance/order'
        }, {
          name: 'FinanceSheet',
          url: '/finance/sheet'
        }]
      }]
    },
    children: [{
      path: 'stored/list',
      name: 'FinanceStored',
      component: '/finance/stored/list',
      meta: {
        title: 'FinanceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FinanceStored',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete', 'payBalanceOrder']
        }]
      }
    }, {
      path: 'stored/order',
      name: 'FinanceStoredOrder',
      component: '/finance/stored/order',
      meta: {
        title: 'FinanceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FinanceStoredOrder',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'stored/set',
      name: 'FinanceStoredSet',
      component: '/finance/stored/set',
      meta: {
        title: 'FinanceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FinanceStoredSet',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'list',
      name: 'FinanceManage',
      component: '/finance/finance/list',
      meta: {
        title: 'FinanceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FinanceManage',
          index: 0,
          auth: ['technicianList', 'changeBalance', 'balanceRecord', 'provinceAgentList', 'cityAgentList', 'areaAgentList']
        }]
      }
    }, {
      path: 'record',
      name: 'FinanceRecord',
      component: '/finance/finance/record',
      meta: {
        title: 'FinanceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FinanceRecord',
          index: 0,
          auth: ['pagedata', 'export', 'wechatCashOut', 'alipayCashOut', 'adapayCashOut', 'underlineCashOut', 'rejectCashOut']
        }]
      }
    }, {
      path: 'order',
      name: 'FinanceOrder',
      component: '/finance/finance/order',
      meta: {
        title: 'FinanceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FinanceOrder',
          index: 0,
          auth: ['pagedata', 'export']
        }]
      }
    }, {
      path: 'sheet',
      name: 'FinanceSheet',
      component: '/finance/finance/sheet',
      meta: {
        title: 'FinanceManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FinanceSheet',
          index: 0,
          auth: ['pagedata', 'export']
        }]
      }
    }]
  },
  // 动态管理
  {
    path: '/dynamic',
    component: 'Layout',
    redirect: '/dynamic/list',
    meta: {
      menuName: 'Dynamic',
      icon: 'icon-dongtai1',
      subNavName: [{
        name: 'DynamicManage',
        url: [{
          name: 'DynamicList',
          url: '/dynamic/list'
        }, {
          name: 'DynamicComment',
          url: '/dynamic/comment'
        }, {
          name: 'DynamicSet',
          url: '/dynamic/set'
        }]
      }]
    },
    children: [{
      path: 'list',
      name: 'DynamicList',
      component: '/dynamic/list',
      meta: {
        title: 'DynamicManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DynamicList',
          index: 0,
          auth: ['pagedata', 'examine', 'view', 'edit', 'delete']
        }]
      }
    }, {
      path: 'comment',
      name: 'DynamicComment',
      component: '/dynamic/comment',
      meta: {
        title: 'DynamicManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DynamicComment',
          index: 0,
          auth: ['pagedata', 'pass', 'reject', 'delete']
        }]
      }
    }, {
      path: 'set',
      name: 'DynamicSet',
      component: '/dynamic/set',
      meta: {
        title: 'DynamicManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DynamicSet',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 门店
  {
    path: '/store',
    component: 'Layout',
    redirect: '/store/classify',
    meta: {
      menuName: 'Store',
      icon: 'iconshangjia',
      subNavName: [{
        name: 'StoreManage',
        url: [{
          name: 'StoreClassify',
          url: '/store/classify'
        }, {
          name: 'StoreList',
          url: '/store/manage'
        }]
      }]
    },
    children: [{
      path: 'classify',
      name: 'StoreClassify',
      component: '/store/classify',
      meta: {
        keepAlive: true,
        title: 'StoreManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'StoreClassify',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'manage',
      name: 'StoreList',
      component: '/store/manage/list',
      meta: {
        keepAlive: true,
        title: 'StoreManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'StoreList',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'manage/edit',
      name: 'StoreAdd',
      component: '/store/manage/edit',
      hidden: true,
      meta: {
        title: 'StoreManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'StoreAdd',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 客户管理
  {
    path: '/custom',
    component: 'Layout',
    redirect: '/custom/user',
    meta: {
      menuName: 'Custom',
      icon: 'iconwodetuandui1',
      subNavName: [{
        name: 'CustomManage',
        url: [{
          name: 'CustomList',
          url: '/custom/user'
        }, {
          name: 'CustomLabel',
          url: '/custom/label'
        }, {
          name: 'CustomBlackList',
          url: '/custom/blacklist'
        }]
      }, {
        name: 'CustomMemberManage',
        url: [{
          name: 'CustomMemberLevel',
          url: '/custom/member/level'
        }, {
          name: 'CustomMemberRights',
          url: '/custom/member/rights'
        }, {
          name: 'CustomMemberSet',
          url: '/custom/member/set'
        }]
      }]
    },
    children: [{
      path: 'user',
      name: 'CustomList',
      component: '/custom/user/list',
      meta: {
        title: 'CustomManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CustomList',
          index: 0,
          auth: ['pagedata', 'view', 'userLabelAndEva', 'deleteTag', 'helpPayBalanceRecord', 'helpPayBalanceOrder', 'memberGrowthRecord', 'memberGrowthChange', 'hideUserType', 'userOrderRecord', 'userHaveCoupon', 'shieldCoach']
          // auth: ['pagedata', 'userLabelAndEva', 'deleteTag', 'helpPayBalanceRecord', 'helpPayBalanceOrder', 'memberGrowthRecord', 'memberGrowthChange', 'hideUserType']
        }]
      }
      // }, {
      //   path: 'user/detail',
      //   name: 'CustomUserDetail',
      //   component: '/custom/user/detail',
      //   hidden: true,
      //   meta: {
      //     title: 'CustomManage',
      //     auth: [],
      //     isOnly: false,
      //     pagePermission: [{
      //       title: 'CustomUserDetail',
      //       index: 0,
      //       auth: []
      //     }]
      //   }
    }, {
      path: 'label',
      name: 'CustomLabel',
      component: '/custom/user/label',
      meta: {
        title: 'CustomManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CustomLabel',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'blacklist',
      name: 'CustomBlackList',
      component: '/custom/user/blacklist',
      meta: {
        title: 'CustomManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CustomBlackList',
          index: 0,
          auth: ['pagedata', 'userLabelAndEva', 'showUserType']
        }]
      }
    }, {
      path: 'member/level',
      name: 'CustomMemberLevel',
      component: '/custom/member/level/list',
      meta: {
        keepAlive: true,
        title: 'CustomManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CustomMemberLevel',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete', 'start', 'stop']
        }]
      }
    }, {
      path: 'member/level/edit',
      name: 'CustomMemberLevelEdit',
      component: '/custom/member/level/edit',
      hidden: true,
      meta: {
        title: 'CustomManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CustomMemberLevelEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'member/rights',
      name: 'CustomMemberRights',
      component: '/custom/member/rights/list',
      meta: {
        keepAlive: true,
        title: 'CustomManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CustomMemberRights',
          index: 0,
          auth: ['pagedata', 'edit']
        }]
      }
    }, {
      path: 'member/rights/edit',
      name: 'CustomMemberRightsEdit',
      component: '/custom/member/rights/edit',
      hidden: true,
      meta: {
        title: 'CustomManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CustomMemberRightsEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'member/set',
      name: 'CustomMemberSet',
      component: '/custom/member/set',
      meta: {
        title: 'CustomManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'CustomMemberSet',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 求救通知
  {
    path: '/notice',
    component: 'Layout',
    redirect: '/notice/list',
    meta: {
      menuName: 'Notice',
      icon: 'icon-tongzhi',
      subNavName: [{
        name: 'NoticeManage',
        url: [{
          name: 'NoticeList',
          url: '/notice/list'
        }, {
          name: 'NoticeSet',
          url: '/notice/set'
        }]
      }]
    },
    children: [{
      path: 'list',
      name: 'NoticeList',
      component: '/notice/list',
      meta: {
        title: 'NoticeManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'NoticeList',
          index: 0,
          auth: ['pagedata', 'read', 'delete']
        }]
      }
    }, {
      path: 'set',
      name: 'NoticeSet',
      component: '/notice/set',
      meta: {
        title: 'NoticeManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'NoticeSet',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 订单通知
  {
    path: '/order',
    component: 'Layout',
    redirect: '/order/notice',
    isHidden: true,
    meta: {
      menuName: 'ShopOrderNotice',
      icon: 'icon-tongzhi'
    },
    children: [{
      path: 'notice',
      name: 'ShopOrderNotice',
      component: '/shop/notice',
      meta: {
        keepAlive: true,
        title: '',
        auth: [],
        isOnly: true,
        pagePermission: [{
          title: 'ShopOrderNotice',
          index: 0,
          auth: ['pagedata', 'read', 'delete']
        }]
      }
    }]
  },
  // 问题反馈
  {
    path: '/feedback',
    component: 'Layout',
    redirect: '/feedback/list',
    meta: {
      menuName: 'Feedback',
      icon: 'iconchefeitixianjilu',
      subNavName: [{
        name: 'FeedbackManage',
        url: [{
          name: 'FeedbackList',
          url: '/feedback/list'
        }, {
          name: 'FeedbackAppealList',
          url: '/feedback/appeal/list'
        }]
      }]
    },
    children: [{
      path: 'list',
      name: 'FeedbackList',
      component: '/feedback/list',
      meta: {
        keepAlive: true,
        title: 'FeedbackManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FeedbackList',
          index: 0,
          auth: ['pagedata', 'view', 'handle']
        }]
      }
    }, {
      path: 'detail',
      name: 'FeedbackDetail',
      component: '/feedback/detail',
      hidden: true,
      meta: {
        title: 'FeedbackManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FeedbackDetail',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'appeal/list',
      name: 'FeedbackAppealList',
      component: '/feedback/appeal/list',
      meta: {
        keepAlive: true,
        title: 'FeedbackManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FeedbackAppealList',
          index: 0,
          auth: ['pagedata', 'view', 'handle', 'badComment']
        }]
      }
    }, {
      path: 'appeal/detail',
      name: 'FeedbackAppealDetail',
      component: '/feedback/appeal/detail',
      hidden: true,
      meta: {
        title: 'FeedbackManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'FeedbackAppealDetail',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 分账系统
  {
    path: '/adapay',
    component: 'Layout',
    redirect: '/adapay/list',
    meta: {
      menuName: 'Adapay',
      icon: 'iconfenzhang',
      subNavName: [{
        name: 'AdapayManage',
        url: [{
          name: 'AdapayList',
          url: '/adapay/list'
        }, {
          name: 'AdapayBalance',
          url: '/adapay/balance'
        }, {
          name: 'AdapaySet',
          url: '/adapay/set'
        }]
      }]
    },
    children: [{
      path: 'list',
      name: 'AdapayList',
      component: '/adapay/list',
      meta: {
        keepAlive: true,
        title: 'AdapayManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AdapayList',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'edit',
      name: 'AdapayListEdit',
      component: '/adapay/edit',
      hidden: true,
      meta: {
        title: 'AdapayManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AdapayListEdit',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'balance',
      name: 'AdapayBalance',
      component: '/adapay/balance',
      meta: {
        title: 'AdapayManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AdapayBalance',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'set',
      name: 'AdapaySet',
      component: '/adapay/set',
      meta: {
        title: 'AdapayManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AdapaySet',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 权限管理
  {
    path: '/account',
    component: 'Layout',
    redirect: '/account/phone',
    meta: {
      menuName: 'Account',
      icon: 'icon-account',
      subNavName: [{
        name: 'AccountPhoneManage',
        url: [{
          name: 'AccountPhone',
          url: '/account/phone'
        }]
      }, {
        name: 'AccountPcManage',
        url: [{
          name: 'AccountRole',
          url: '/account/role'
        }, {
          name: 'AccountList',
          url: '/account/list'
        }]
      }, {
        name: 'AccountOperManage',
        url: [{
          name: 'AccountOperLog',
          url: '/account/log'
        }]
      }]
    },
    children: [{
      path: 'phone',
      name: 'AccountPhone',
      component: '/account/phone',
      meta: {
        title: 'AccountManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AccountPhone',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'role',
      name: 'AccountRole',
      component: '/account/role',
      hidden: true,
      meta: {
        title: 'AccountManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AccountRole',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'list',
      name: 'AccountList',
      component: '/account/list',
      hidden: true,
      meta: {
        title: 'AccountManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AccountList',
          index: 0,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'log',
      name: 'AccountOperLog',
      component: '/account/log',
      hidden: true,
      meta: {
        title: 'AccountManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'AccountOperLog',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // diy
  {
    path: '/diy',
    component: 'Layout',
    redirect: '/diy/color',
    meta: {
      menuName: 'Diy',
      icon: 'icon-chaifenyemian',
      subNavName: [{
        name: 'DiyManage',
        url: [{
          name: 'DiyColor',
          url: '/diy/color'
        }, {
          name: 'DiyTabbar',
          url: '/diy/tabbar'
        }, {
          name: 'DiySet',
          url: '/diy/set'
        }]
      }]
    },
    children: [{
      path: 'color',
      name: 'DiyColor',
      component: '/diy/color',
      meta: {
        title: 'DiyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DiyColor',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'tabbar',
      name: 'DiyTabbar',
      component: '/diy/tabbar',
      meta: {
        title: 'DiyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DiyTabbar',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'set',
      name: 'DiySet',
      component: '/diy/set',
      meta: {
        title: 'DiyManage',
        auth: [],
        isOnly: false,
        pagePermission: [{
          title: 'DiySet',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  // 系统
  {
    path: '/sys',
    component: 'Layout',
    redirect: '/sys/upgrade',
    meta: {
      menuName: 'System',
      icon: 'icon-xitong',
      subNavName: [{
        name: 'SystemVersion',
        url: [{
          name: 'SystemUpgrade',
          url: '/sys/upgrade',
          auth: 1
        }, {
          name: 'SystemExamine',
          url: '/sys/examine',
          auth: 1
        }]
      }, {
        name: 'SystemSetting',
        url: [{
          name: 'SystemWechat',
          url: '/sys/wechat',
          auth: 1
        },
        {
          name: 'SystemH5',
          url: '/sys/h5',
          auth: 1
        },
        {
          name: 'SystemApp',
          url: '/sys/app',
          auth: 1
        },
        {
          name: 'SystemEmploy',
          url: '/sys/employ',
          auth: 1
        },
        {
          name: 'SystemLink',
          url: '/sys/link',
          auth: 1
        },
        {
          name: 'SystemInfo',
          url: '/sys/info',
          auth: 1
        },
        {
          name: 'SystemPayment',
          url: '/sys/payment',
          auth: 1
        },
        {
          name: 'SystemUpload',
          url: '/sys/upload',
          auth: 1
        },
        {
          name: 'SystemTransaction',
          url: '/sys/transaction',
          auth: 1
        },
        {
          name: 'SystemInformation',
          url: '/sys/information',
          auth: 1
        }
        ]
      }, {
        name: 'SystemMessageSet',
        url: [
          {
            name: 'SystemAliyun',
            url: '/sys/aliyun',
            auth: 1
          },
          {
            name: 'System7moor',
            url: '/sys/7moor',
            auth: 1
          },
          {
            name: 'SystemYunxin',
            url: '/sys/yunxin',
            auth: 1
          },
          {
            name: 'SystemVirtual',
            url: '/sys/virtual-set',
            auth: 1
          },
          {
            name: 'SystemReminder',
            url: '/sys/reminder',
            auth: 1
          },
          {
            name: 'SystemMessage',
            url: '/sys/message',
            auth: 1
          },
          {
            name: 'SystemAllNotice',
            url: '/sys/notice',
            auth: 1
          },
          {
            name: 'SystemNoticeManage',
            url: '/sys/notice-manage',
            auth: 1
          }]
      }, {
        name: 'SystemOther',
        url: [{
          name: 'SystemFdd',
          url: '/sys/fdd-set',
          auth: 1
        }, {
          name: 'SystemPrint',
          url: '/sys/print',
          auth: 1
        },
        {
          name: 'SystemCarFee',
          url: '/sys/car-fee-set',
          auth: 1
        },
        {
          name: 'SystemCity',
          url: '/sys/city',
          auth: 1
        },
        {
          name: 'SystemTravel',
          url: '/sys/travel',
          auth: 1
        },
        {
          name: 'SystemOther',
          url: '/sys/other',
          auth: 1
        }
        ]
      }]
    },
    children: [{
      path: 'upgrade',
      name: 'SystemUpgrade',
      component: '/system/upgrade',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemUpgrade',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'examine',
      name: 'SystemExamine',
      component: '/system/examine',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemExamine',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'wechat',
      name: 'SystemWechat',
      component: '/system/wechat',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemWechat',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'h5',
      name: 'SystemH5',
      component: '/system/h5',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemH5',
          index: 0,
          auth: []
        }]
      }
    },
    {
      path: 'app',
      name: 'SystemApp',
      component: '/system/app',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemApp',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'employ',
      name: 'SystemEmploy',
      component: '/system/employ',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemEmploy',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'link',
      name: 'SystemLink',
      component: '/system/link',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemLink',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'info',
      name: 'SystemInfo',
      component: '/system/info',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemInfo',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'payment',
      name: 'SystemPaymentWechat',
      component: '/system/payment/wechat',
      meta: {
        title: 'SystemSetting',
        isOnly: false,
        auth: 1,
        pagePermission: [{
          title: 'SystemPaymentWechat',
          url: 'payment',
          index: 0,
          auth: []
        }, {
          title: 'SystemPaymentAlipay',
          url: 'alipay',
          index: 1,
          auth: []
        }]
      }
    },
    {
      path: 'alipay',
      name: 'SystemPaymentAlipay',
      component: '/system/payment/alipay',
      meta: {
        title: 'SystemSetting',
        isOnly: false,
        auth: 1,
        pagePermission: [{
          title: 'SystemPaymentWechat',
          url: 'payment',
          index: 0,
          auth: []
        }, {
          title: 'SystemPaymentAlipay',
          url: 'alipay',
          index: 1,
          auth: []
        }]
      }
    }, {
      path: 'upload',
      name: 'SystemUpload',
      component: '/system/upload',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemUpload',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'transaction',
      name: 'SystemTransaction',
      component: '/system/transaction',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemTransaction',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'information',
      name: 'SystemInformation',
      component: '/system/information',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemInformation',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'aliyun',
      name: 'SystemAliyun',
      component: '/system/aliyun',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemAliyun',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: '7moor',
      name: 'System7moor',
      component: '/system/7moor',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'System7moor',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'yunxin',
      name: 'SystemYunxin',
      component: '/system/yunxin',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemYunxin',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'virtual-set',
      name: 'SystemVirtualSet',
      component: '/system/virtual/set',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemVirtualSet',
          url: 'virtual-set',
          index: 0,
          auth: []
        }, {
          title: 'SystemVirtualRecord',
          url: 'virtual-record',
          index: 1,
          auth: ['pagedata', 'play', 'download']
        }]
      }
    }, {
      path: 'virtual-record',
      name: 'SystemVirtualRecord',
      component: '/system/virtual/record',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemVirtualSet',
          url: 'virtual-set',
          index: 0,
          auth: []
        }, {
          title: 'SystemVirtualRecord',
          url: 'virtual-record',
          index: 1,
          auth: ['pagedata', 'play', 'download']
        }]
      }
    }, {
      path: 'reminder',
      name: 'SystemReminder',
      component: '/system/reminder',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemReminder',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'message',
      name: 'SystemMessage',
      component: '/system/message',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemMessage',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'notice',
      name: 'SystemAllNotice',
      component: '/system/notice',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemAllNotice',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'notice-manage',
      name: 'SystemNoticeManage',
      component: '/system/notice-manage',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemNoticeManage',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'fdd-set',
      name: 'SystemFddSet',
      component: '/system/fdd/set',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemFddSet',
          url: 'fdd-set',
          index: 0,
          auth: []
        }, {
          title: 'SystemFddRecord',
          url: 'fdd-record',
          index: 1,
          auth: ['pagedata', 'toFddSign', 'fddSignUrl', 'fddMerchantSign', 'delete']
        }]
      }
    }, {
      path: 'fdd-record',
      name: 'SystemFddRecord',
      component: '/system/fdd/record',
      meta: {
        keepAlive: true,
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemFddSet',
          url: 'fdd-set',
          index: 0,
          auth: []
        }, {
          title: 'SystemFddRecord',
          url: 'fdd-record',
          index: 1,
          auth: ['pagedata', 'toFddSign', 'fddSignUrl', 'fddMerchantSign', 'delete']
        }]
      }
    }, {
      path: 'print',
      name: 'SystemPrint',
      component: '/system/print',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemPrint',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'car-fee-set',
      name: 'SystemCarFeeSet',
      component: '/system/car-fee/set',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemCarFeeSet',
          url: 'car-fee-set',
          index: 0,
          auth: []
        }, {
          title: 'SystemCarFeeCity',
          url: 'car-fee-city',
          index: 1,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'car-fee-city',
      name: 'SystemCarFeeCity',
      component: '/system/car-fee/city',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemCarFeeSet',
          url: 'car-fee-set',
          index: 0,
          auth: []
        }, {
          title: 'SystemCarFeeCity',
          url: 'car-fee-city',
          index: 1,
          auth: ['pagedata', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'city',
      name: 'SystemCity',
      component: '/system/city',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemCity',
          index: 0,
          auth: ['pagedata', 'mobilecode', 'add', 'edit', 'delete']
        }]
      }
    }, {
      path: 'travel',
      name: 'SystemTravel',
      component: '/system/travel',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemTravel',
          index: 0,
          auth: []
        }]
      }
    }, {
      path: 'other',
      name: 'SystemOther',
      component: '/system/other',
      meta: {
        title: 'SystemSetting',
        auth: 1,
        isOnly: false,
        pagePermission: [{
          title: 'SystemOther',
          index: 0,
          auth: []
        }]
      }
    }]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/permission.js